export const NarrativeFormField = {
  NARRATIVE_BACKGROUND: 'narrativeBackground',
  NARRATIVE_SYSTEM_SUMMARIES: 'narrativeSystemSummaries',
  NARRATIVE_CLINICAL_OVERVIEW: 'narrativeClinicalOverview',
  NARRATIVE_SKILLED_NEEDS: 'narrativeSkilledNeeds',
  NARRATIVE_ADL_NEEDS: 'narrativeAdlNeeds',
  NARRATIVE_PATIENT_SERVICES: 'narrativePatientServices',
  NARRATIVE_CARE_COORDINATION: 'narrativeCareCoordination',
  NARRATIVE_PATIENT_GOALS: 'narrativePatientGoals',
  NARRATIVE_CLINICAL_EDUCATION: 'narrativeClinicalEducation',
  NARRATIVE_FINAL_NOTES: 'narrativeFinalNotes'
} as const

export type NarrativeFormField = (typeof NarrativeFormField)[keyof typeof NarrativeFormField]
